/**
 * @description 查詢優惠活動列表資料 EVENT_TYPE 用
*/
export enum PromotionEventType {
    /** 全部 */
    All='ALL',
    /** 活動列表 */
    Promotion = 'P',
    /** 得獎公告 */
    PrizeWinner = 'W',
    /** 加值服務 */
    ValueAdd = 'V'
}
